import { BID_SUBMISSION_STATUS } from 'utils/constants'

export const toPieChartData = data => {
  if (!data) return {}
  let totalCount = 0
  let totalBidValue = 0
  const piesObj = {
    pieByValue: [],
    pieByCount: []
  }

  const pies = Object.keys(data).reduce((a, item) => {
    const elem = data[item]
    totalBidValue += elem.totalBidValue
    totalCount += elem.count

    piesObj.pieByValue.push({
      id: BID_SUBMISSION_STATUS[item],
      label: BID_SUBMISSION_STATUS[item],
      value: elem.totalBidValue,
      color: getColor(item)
    })

    piesObj.pieByCount.push({
      id: BID_SUBMISSION_STATUS[item],
      label: BID_SUBMISSION_STATUS[item],
      value: elem.count,
      color: getColor(item)
    })

    return piesObj
  }, [])

  return {
    pies,
    totalCount,
    totalBidValue
  }
}

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

const getColor = status => {
  const colors = {
    EARLY: '#ffd000',
    ONTIME: '#92D050',
    LATE: '#ED7D31',
    PASTDUE: '#be1e2d',
    UPCOMING: '#45a499'
  }
  return colors[status]
}
